import {historyLine, thumbDownLine, thumbUpLine, timeLine} from 'src/utils/icons';
import BaseButton from './BaseButton';
import RemixIcon from './RemixIcon';
import Dropdown from './Dropdown';

const allMenuItems = [
  {
    icon: timeLine,
    text: 'Recent',
    key: 'recent'
  },
  {
    icon: historyLine,
    text: 'Oldest',
    key: 'oldest'
  },
  {
    icon: thumbUpLine,
    text: 'Best rated',
    key: 'best'
  },
  {
    icon: thumbDownLine,
    text: 'Worst rated',
    key: 'worst'
  }
];

type Props = {
  sortId: string;
  onChange: (key: string) => void;
};

const PlacesSortSelect = ({sortId, onChange}: Props) => {
  const activeItem = allMenuItems.find((item) => item.key === sortId);
  const items = allMenuItems
    .filter((item) => item.key !== sortId)
    .map((item) => ({...item, onAction: () => onChange(item.key)}));

  return (
    <Dropdown items={items}>
      <BaseButton buttonVariant="text">
        <div className="-ml-[2px] mr-2 max-[500px]:hidden">
          <RemixIcon icon={activeItem?.icon} size={18} color="var(--text-color)" />
        </div>

        <div className="-ml-[2px] -mr-[2px] hidden max-[500px]:block">
          <RemixIcon icon={activeItem?.icon} size={18} color="var(--text-color)" />
        </div>

        <span className="max-[500px]:hidden">{activeItem?.text}</span>
      </BaseButton>
    </Dropdown>
  );
};

export default PlacesSortSelect;
